import styled from 'styled-components'
import {spacing} from '../../theme/spacing'

const FlexBox = styled.div<{
    spacing?: number
    justifyContent?: FlexAlignments
    alignItems?: FlexAlignments
    width?: string
    height?: string
    minHeight?: string
    padding?: number
    flex?: string
    flexWrap?: string
}>`
    display: flex;
    ${(props) => (props.spacing ? `gap: ${spacing(props.spacing)};` : '')}
    ${(props) => (props.justifyContent ? `justify-content: ${props.justifyContent};` : '')}
    ${(props) => (props.alignItems ? `align-items: ${props.alignItems};` : '')}
    ${(props) => (props.width ? `width: ${props.width};` : '')}
    ${(props) => (props.height ? `height: ${props.height};` : '')}
    ${(props) => (props.minHeight ? `min-height: ${props.minHeight};` : '')}
    ${(props) => (props.padding ? `padding: ${spacing(props.padding)};` : '')}
    ${(props) => (props.flex ? `flex: ${props.flex};` : '')}
    ${(props) => (props.flexWrap ? `flex-wrap: ${props.flexWrap};` : '')}
`

export enum FlexAlignments {
    Center = 'center',
    SpaceAround = 'space-around',
    SpaceBetween = 'space-between',
    FlexStart = 'flex-start',
    FlexEnd = 'flex-end',
    Stretch = 'stretch',
    SpaceEvenly = 'space-evenly',
}

export const FlexRow = styled(FlexBox)`
    flex-direction: row;
`

export const FlexCol = styled(FlexBox)`
    flex-direction: column;
`
